import { render, staticRenderFns } from "./GenderList.vue?vue&type=template&id=3f9fa9a6"
import script from "./GenderList.vue?vue&type=script&lang=js"
export * from "./GenderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports